import {Metric} from 'app_api/projects/metrics/types';
import {metricsClient} from 'common/report/queries/app-api/metrics';
import {ApiResource} from 'common/util/model-resource/api-resource';

export class MetricsResource extends ApiResource<Metric> {
  apiClient = metricsClient;
}
